module.exports = __webpack_public_path__ + "static/media/games.4cc07525.png";